import React, { useEffect } from "react";
import { VStack, Box, useBreakpointValue } from "@chakra-ui/react";
import { SignupForm } from "../Components/custom/SignupForm";
import { Stepper } from "../Components/custom/Stepper";
import { getDomainConfig } from "../Utils/dynamicBranding";
import { useThemeContext } from "../Context/ThemeContext";
import { useTheme } from "next-themes";

export const Signup = ({referralCode}) => {
  const { themeConfig } = useThemeContext();
  const { resolvedTheme } = useTheme();
  const theme = themeConfig[resolvedTheme === 'dark' ? 'dark' : 'light'];

  useEffect(() => {
    const config = getDomainConfig();
    document.title = `Signup - ${config.title}`;
  }, []);
  
  // Responsive padding values
  const pagePaddingX = useBreakpointValue({ base: 3, sm: 4, md: 6 });
  const pagePaddingTop = useBreakpointValue({ base: 2, sm: 3, md: 4 });
  
  return (
    <VStack 
      height="100vh" 
      paddingTop={pagePaddingTop}
      paddingX={pagePaddingX}
      width="100%"
      overflowX="hidden"
      spacing={4}
      bg={theme.bgPrimary}
      transition="all 0.3s ease"
    >
      <Box width="100%" maxWidth="100%">
        <Stepper currentStep={0} />
      </Box>
      <Box width="100%" maxWidth="100%" flex="1">
        <SignupForm referralCode={referralCode}/>
      </Box>
    </VStack>
  );
};